import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { appConfig } from '../../../../config/app';
import { CustomEvents } from '../../../../constants/analytics.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useForm from '../../../../helpers/useForm';
import useLogEventInAnalytics from '../../../../hooks/useLogAnalyticsEvent';
import { useTipification } from '../../../../hooks/useTipification';
import {
  cancelPolicyRequest,
  cancellationReasons,
} from '../../../../services/policy/policy.service';
import CancelPolicyValidation from './CancelPolicy.validations';
import { useStyle } from './styles';

const useCancelPolicy = () => {
  const classes = useStyle();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [inProcess, setInProcess] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const history = useHistory();
  const { user } = useAuthDataContext();
  const { policy_id } = useParams<any>();

  useEffect(() => {
    getCancelReasons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [cancelReasonsList, setCancelReasonsList] = useState([]);
  const [tramitNumber, setTramitNumber] = useState('');
  const { logEvent } = useLogEventInAnalytics();
  const { trackEvent, events } = useTipification();

  const getCancelReasons = async () => {
    await cancellationReasons().then((reasonsList) => {
      setCancelReasonsList(reasonsList.data);
    });
  };

  const [defaultValues] = useState({
    email: user.email,
    phone: user.phone.split('-').join(''),
    reason_id: '',
  });

  const onSubmit = async () => {
    dataLayerPush('cuenta_cancelar_poliza_confirmado', user?.id);
    setLoading(true);
    await cancelPolicyRequest({ ...values }, policy_id)
      .then(async (response) => {
        // Taggeo baja de póliza
        await logEvent(CustomEvents.ACCOUNT_CANCEL_POLICY, {
          app: appConfig?.NAME,
        });
        trackEvent(events.POLICY_CANCEL_ONLINE_REQUEST);
        if (response.data.response.code === 400) {
          setInProcess(true);
          setLoading(false);
        } else if (response.data.response.transactionid) {
          setLoading(false);
          setOpen(true);
          setTramitNumber(response.data.response.transactionid);
        } else {
          setLoading(false);
          setError(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(true);
      });
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    onSubmit,
    CancelPolicyValidation,
    defaultValues
  );

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const handleDiscardRequest = () => {
    redirectHome();
  };

  const handleWorkflowSuccess = () => {
    redirectHome();
  };

  const handleFailure = () => {
    setError(false);
    redirectHome();
  };

  const handleConfirm = () => {
    setConfirm(true);
  };

  return {
    loading,
    open,
    setOpen,
    tramitNumber,
    handleWorkflowSuccess,
    classes,
    errors,
    handleChange,
    values,
    handleSubmit,
    setConfirm,
    error,
    setError,
    inProcess,
    setInProcess,
    handleFailure,
    confirm,
    cancelReasonsList,
    handleDiscardRequest,
    history,
    handleConfirm,
  };
};

export default useCancelPolicy;
